<template>
  <div>
    <UserPreferences ref="user-preferences" style="z-index: 2000;"></UserPreferences>
    <Notifications ref="notifications" style="z-index: 2000;"></Notifications>
    <NotificationData></NotificationData>
    <Geofences ref="geofences" style="z-index: 2000;"></Geofences>
    <div v-b-toggle.collapse-2>
      <img src="@/assets/img/menu.svg" />
    </div>
    <b-collapse id="collapse-2" class="menu text-dark" v-model="visible">
      <div class="item-menu py-1 px-2 border-top" @click="showGeofences"> Geocercas </div>
      <div class="item-menu py-1 px-2 border-top" @click="notifications"> Notificaciones </div>
      <div class="item-menu py-1 px-2 border-top" @click="preferences"> Preferencias </div>
      <div class="item-menu py-1 px-2 border-top" @click="refresh"> Actualizar </div>
      <div class="item-menu py-1 px-2 border-top" @click="closeSession"> Cerrar Sesión </div>
    </b-collapse>
  </div>
</template>

<script lang="ts">
import devicesModule from '@/store/modules/devices.module';
import { Component, Vue } from 'vue-property-decorator';
import UserPreferences from '@/components/modals/UserPreferences.vue';
import Notifications from '@/components/modals/Notifications.vue';
import Geofences from '@/components/geofences/modals/Geofences.vue';
import NotificationData from '../modals/NotificationData.vue';

@Component({
  components: { UserPreferences, Notifications, Geofences, NotificationData }
})
export default class MenuHeader extends Vue {
  visible = false

  getDevices() {
    devicesModule.getDevices()
  }

  getPositions() {
    devicesModule.getPositions()
  }

  async refresh() {
    location.reload()
    this.visible = false
  }

  async preferences() {
    const modal: any = this.$refs['user-preferences']
    modal.show();
  }

  async notifications() {
    const modal: any = this.$refs['notifications']
    modal.show();
  }

  showGeofences() {
    const modal: any = this.$refs['geofences']
    console.log(modal)
    modal.show();
  }

  closeSession() {
    this.visible = false
    localStorage.clear()
    location.reload()
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/variables.sass'
img
   height: 20px
.menu
    position: absolute
    z-index: 100
    height: fit-content
    top: 60px
    right: 0px
    z-index: 100
    display: block
    font-size: 18px
    background: #f8f9fa
    .item-menu
        cursor: pointer
        user-select: none
        &:hover
            transition: all 0.1s ease
            background: $secondary
            color: #fff
</style>
